import { useState } from 'react';
import Modal from '../../components/Modal/Modal'
import Snippet from '../../components/Snippet/Snippet'
import CalendarClass from '../../assets/code-snippets/calendar/classSnip'
import { implement } from '../../assets/code-snippets/calendar/snip'
import { scssPattern, cssPattern } from '../../assets/code-snippets/calendar/styleSnip'

const Calendar = () => {

    const [toggleSnip, setToggleSnip] = useState(false)

    const [jsModal, setJsModal] = useState({
        display: !1,
        cssClass: 'fluid top0',
        scroll: !0,
        header: '<h1>Calendar Class</h1>'
    })
    const [scssModal, setScssModal] = useState({
        display: !1,
        cssClass: 'fluid top0',
        scroll: !0,
        header: '<h1>Calendar Styling Sheets</h1>'
    })

    const toggleJsModal = () => {
        setJsModal(prev => ({
            ...prev, display: !prev.display
        }))
    }
    const toggleScssModal = () => {
        setScssModal(prev => ({
            ...prev, display: !prev.display
        }))
    }
    const toggleStylesheetSnippets = () => {
        setToggleSnip(prev => !prev)
    }

    return <div className="container lg py-1" id="intro">

        <Modal structure={jsModal} onToggle={toggleJsModal}>
            <Snippet code={CalendarClass} language='javascript' />
        </Modal>
        <Modal structure={scssModal} onToggle={toggleScssModal}>
            <button onClick={toggleStylesheetSnippets} className="btn primary lg">Switch to {toggleSnip ? 'SCSS' : 'CSS'} Snippet</button>
            {toggleSnip ? <Snippet code={cssPattern} language='css' /> : <Snippet code={scssPattern} language='scss' />}
        </Modal>

        <div className="container fluid">
            <p className="text xl"><a href="#intro" className="link">&#128279;</a> Dynamic Calendar</p>

            <p className="text md">Calendar is implemented using <button onClick={toggleJsModal} className='btn md primary' title='CLICK ME!'><code>Calendar</code></button> class, therefore to create the calendar element is as simple as defining a HTML element having a specific id or class and then call the <code>constructCalendar</code> method of  <button onClick={toggleJsModal} className='btn md primary' title='CLICK ME!'><code>Calendar</code></button> class, this class must create the entire HTML content of the calendar element. Also you'll need the <button onClick={toggleScssModal} className="btn md primary">style</button> file responsible for styling the calendar element.</p>

            <p className="text lg info">Access the <code>Calendar</code> class by clicking the button above.</p>

            <p className="text md">Calendar class has a dependency as Luxon.js library for which documentation can be found here: <a href="https://moment.github.io/luxon/" target="_blank" rel="noopener noreferrer">https://moment.github.io/luxon/</a> and here: <a href="https://github.com/moment/luxon" target="_blank" rel="noopener noreferrer">https://github.com/moment/luxon</a>, this library must be imported or dowloaded and fetched into HTML document just before <code>Calendar</code> class.</p>

            <span className="badge lg warning gradient">APPLICATION IN REAL ENVIRONMENT</span>
            <Snippet code={implement} language='html' />

            <p className="text md"><code>captureCalendarDate()</code> function is an external function used to capture the date once one of the calendar day is clicked.</p>

            <p className="text md"><code>SelectedDates</code> object will highlight the days defined into this, within the calendar body, for example having defined the object with the date:</p>
            <div className="container sm">
                <Snippet code={`SelectedDates: {
    day: 1,
    month: 1,
    year: 2021
}`} language='json' />
            </div>
            <p className="text md">will highlight only the 1st of January 2021, add multiple dates if needed.</p>
        </div>
    </div>
}

export default Calendar